import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import "./QarManagers.css";
import MaterialTable from "material-table";
import { managerReviewEmployeesTableOptions } from "../../helper/constants";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import QarAdminEmployeeInfoRow from "./QarAdminEmployeeInfoRow";

const QarManagerEmployees = inject("RootStore")(
  observer(({ RootStore }) => {
    useEffect(() => {
      RootStore.qarStore
        .getEmployeesByManagerReviewId(
          RootStore.qarStore.currentlySelectedManager.managerReviewID,
          RootStore.qarStore.currentlySelectedAccountForReview.id,
          RootStore.qarStore.currentComplianceReviewId
        )
        .catch(console.log);
    }, [RootStore.qarStore]);

    const shouldIncludeIsChameleonAdmin = () =>
      RootStore.qarStore.employeesByManagerReview.employees.find(
        (x) => x.isChameleonAdmin
      );

    const renderIsChameleonColumn = () =>
      shouldIncludeIsChameleonAdmin() !== undefined ? (
        <TableCell align="left">Is Chameleon Admin</TableCell>
      ) : (
        <></>
      );

    return (
      <>
        <div className="styled-table table-hover">
          {RootStore.qarStore.employeesByManagerReview.employees?.length > 0 ? (
            <MaterialTable
              title=""
              data={RootStore.qarStore.employeesByManagerReview.employees}
              options={managerReviewEmployeesTableOptions}
              components={{
                Header: () => {
                  return (
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Employee Info</TableCell>
                        <TableCell align="left">Username</TableCell>
                        <TableCell align="left">Roles</TableCell>
                        <TableCell align="left">Action</TableCell>
                        <TableCell align="left">Ticket ID</TableCell>
                        <TableCell align="left">Comment</TableCell>
                        <TableCell align="left">Delegate To</TableCell>
                        <TableCell align="left"></TableCell>
                        {renderIsChameleonColumn()}
                      </TableRow>
                    </TableHead>
                  );
                },
                Row: ({ data }) => {
                  const emp = data;
                  return <QarAdminEmployeeInfoRow emp={emp} isUnmatchedAccount={false} />;
                },
              }}
            ></MaterialTable>
          ) : null}
          {RootStore.qarStore.employeesByManagerReview.unmatchedAccounts?.length > 0 ? (
            <MaterialTable
              title="System accounts"
              data={
                RootStore.qarStore.employeesByManagerReview.unmatchedAccounts
              }
              options={managerReviewEmployeesTableOptions}
              components={{
                Header: () => {
                  return (
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Employee Info</TableCell>
                        <TableCell align="left">Username</TableCell>
                        <TableCell align="left">Roles</TableCell>
                        <TableCell align="left">Action</TableCell>
                        <TableCell align="left">Ticket ID</TableCell>
                        <TableCell align="left">Comment</TableCell>
                        <TableCell align="left">Delegate To</TableCell>
                        <TableCell align="left"></TableCell>
                      </TableRow>
                    </TableHead>
                  );
                },
                Row: ({ data }) => {
                  const emp = data;
                  return <QarAdminEmployeeInfoRow emp={emp} isUnmatchedAccount={true} />;
                },
              }}
            ></MaterialTable>
          ) : null}
        </div>
      </>
    );
  })
);

export default QarManagerEmployees;
